/** Disparado tras crear/editar/eliminar usuarios o cambiar rol/empresa en Gestión de Usuarios. */
export const VAULT_ADMIN_USERS_CHANGED_EVENT = 'vault-admin-users-changed';

export function notifyVaultAdminUsersChanged(): void {
  if (typeof globalThis.window === 'undefined') {
    return;
  }
  globalThis.window.dispatchEvent(new CustomEvent(VAULT_ADMIN_USERS_CHANGED_EVENT));
}
